import { cn } from '../../utils/cn';

export function Skeleton({ className, ...props }) {
  return (
    <div
      data-ds-id="ds/feedback/skeleton"
      className={cn('animate-shimmer rounded-ds-md bg-skeleton', className)}
      aria-hidden="true"
      {...props}
    />
  );
}
